import { formatDuration } from '../../utils/formatters'

export default function TimeRow({ label, minutes, percent }) {
  return (
    <div>
      <div className="mb-2 flex items-center justify-between text-xs font-bold">
        <span>{label}</span>
        <span>{formatDuration(minutes)}</span>
      </div>
      <div className="h-2.5 overflow-hidden rounded-full bg-[#E5DED3]">
        <div className="h-full rounded-full bg-[#8A6819]" style={{ width: `${percent}%` }} />
      </div>
    </div>
  )
}
